import { FC } from "react";
import { Box, Paper, Skeleton, Typography } from "@mui/material";
import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import { EnrollmentSummaryByOrgUnit } from "../../../../../services/reports.service";

const STATUS_COLORS = {
	active: "#1D9E75",
	completed: "#7F77DD",
	disenrolled: "#D85A30",
	paused: "#888780",
};

interface ByOrgUnitChartProps {
	data: EnrollmentSummaryByOrgUnit[];
	isLoading?: boolean;
}

const ByOrgUnitChart: FC<ByOrgUnitChartProps> = ({ data, isLoading }) => {
	if (isLoading) {
		return (
			<Paper variant="outlined" sx={{ p: 3 }}>
				<Skeleton variant="rectangular" height={280} />
			</Paper>
		);
	}

	if (!data || data.length === 0) {
		return (
			<Paper variant="outlined" sx={{ p: 4, textAlign: "center" }}>
				<Typography variant="body2" color="text.secondary">
					No enrollment data available for the selected filters.
				</Typography>
			</Paper>
		);
	}

	return (
		<Paper variant="outlined" sx={{ p: 3 }}>
			<Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
				Enrollment status by org unit
			</Typography>
			<Box sx={{ width: "100%", height: 320 }}>
				<ResponsiveContainer width="100%" height="100%">
					<BarChart
						data={data}
						margin={{ top: 16, right: 24, bottom: 0, left: 0 }}
					>
						<CartesianGrid strokeDasharray="3 3" vertical={false} />
						<XAxis dataKey="orgUnit" />
						<YAxis allowDecimals={false} />
						<Tooltip />
						<Legend />
						<Bar
							dataKey="active"
							name="Active"
							stackId="status"
							fill={STATUS_COLORS.active}
						/>
						<Bar
							dataKey="completed"
							name="Completed"
							stackId="status"
							fill={STATUS_COLORS.completed}
						/>
						<Bar
							dataKey="disenrolled"
							name="Disenrolled"
							stackId="status"
							fill={STATUS_COLORS.disenrolled}
						/>
						<Bar
							dataKey="paused"
							name="Paused"
							stackId="status"
							fill={STATUS_COLORS.paused}
						/>
					</BarChart>
				</ResponsiveContainer>
			</Box>
		</Paper>
	);
};

export default ByOrgUnitChart;
